module.exports = __webpack_public_path__ + "img/piramide.cf423aaf.svg";